import { Component, Prop, Vue } from "vue-property-decorator";

@Component({})
export default class ErrorPopupComponent extends Vue {
  @Prop()
  public componentName!: string;
  @Prop()
  public errorMessage!: string;

  @Prop()
  public isErrorPopup!: string;

  public created() {
    this.$nextTick(() => {
      if (this.errorMessage) {
        this.$bvModal.show("error-modal-center");
      }
    });
  }

  public closePopup() {
    this.$emit("closdedErrorPopup", true);
    this.$bvModal.hide("error-modal-center");
  }

  public hide(event: any) {
    if (event) {
      this.$emit("closdedErrorPopup", true);
    }
  }
}
